import { Radio, RadioProps } from "@mui/material";
import React, { FC } from "react";

import "./Radio.scss";

interface IRadioProps extends RadioProps {
	"data-testid": string;
	value: string;
	label: string;
	className?: string;
	labelClassName?: string;
}

const CutomRadio: FC<IRadioProps> = (props) => {
	const radioProps = {
		...props,
	};

	delete radioProps["labelClassName"];

	return (
		<div className="RadioContainer" data-testid={props["data-testid"]}>
			<Radio
				{...radioProps}
				className={props.className}
				data-testid={props["data-testid"] + "-" + props.value + "-radio"}
			/>
			<div
				className={props.labelClassName}
				data-testid={props["data-testid"] + "-" + props.label + "-label"}
			>
				{props.label}
			</div>
		</div>
	);
};

export default CutomRadio;
